import styled from 'styled-components';

export const SForm = styled.form`
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const SInputUsername = styled.div`
  height: 34%;
`;

export const SInputPassword = styled.div`
  height: 45%;
`;

export const SErrorLabel = styled.label`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12.5px;
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.error};
`;

export const SWarningLabel = styled(SErrorLabel)`
  color: ${({ theme }) => theme.colors.icon};
`;

//-----------------------------------------------------
//        Change Password
//-----------------------------------------------------
export const SWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 10px;
  padding: 60px;
`;

export const SImageColor = styled.i`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 35px;
`;

export const SModalTitle = styled.div`
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.icon};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 35px;
  font-weight: 600;
`;

export const SSubTitle = styled.div`
  margin-top: 15px;
  margin-bottom: 40px;
  letter-spacing: 0.21px;
  color: ${({ theme }) => theme.colors.quinaryText};
  font-size: 15px;
  font-weight: normal;
`;

export const SButton = styled.button`
  height: 50px;
  width: 255px;

  border: none;
  border-radius: 5px;
  font-size: 17.5px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryText};
`;

//-----------------------------------------------------
//        Forgot Password
//-----------------------------------------------------

export const SInputUsernameOrEmailAddress = styled.div`
  height: 34%;
`;

export const SErrorLabelWrapTxt = styled.label`
  width: 100%;
  white-space: wrap;
  height: 12.5px;
  font-size: 12.5px;
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.error};
`;

export const SWideSubmitBtn = styled.button`
  height: 50px;
  width: 213px;
  margin-bottom: 5px;
  border: none;
  border-radius: 5px;
  font-size: 17.5px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const SArrowLeftIcon = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 22.5px;
  cursor: pointer;
`;
